import * as React from 'react';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

export default function NotificationBar({open,setOpen}) {


  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}   anchorOrigin={{ vertical: 'top', horizontal: 'right' }} className='bg-transparent'>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          // sx={{ width: '100%',backgroundColor:"#DF73FF",color:"#222222" }}
          sx={{ width: '100%',backgroundColor:"#ffffff",color:"#222222",boxShadow:"0px 3px 4px rgba(0, 0, 0, 0.2)",
           ' & .MuiAlert-icon': {
      color: '#DF73FF', 
    },
           }}
        >
       Form has been submitted successfully!

        </Alert>
      </Snackbar>
    </div>
  );
}
